import {Component} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {Customer} from 'src/app/raintree/interface/customer-profile/customer';
import {RaintreeResponse} from 'src/app/raintree/interface/raintree-response';
import {CustomerProfileTransmissionService} from 'src/app/raintree/transmission/customer-profile-transmission/customer-profile-transmission.service';
import {RequestMapperService} from 'src/app/request-mapper.service';
import {GlobalService} from 'src/app/services/global.service';
import {ToastMessageService} from 'src/app/services/toast-message.service';

@Component({
	selector: 'fb-profile-account',
	templateUrl: './profile-account.component.html',
	styleUrls: ['./profile-account.component.scss']
})
export class ProfileAccountComponent {
	constructor(
		private _globalService: GlobalService,
		private _fb: FormBuilder,
		private _customerProfile: CustomerProfileTransmissionService,
		public _toast: ToastMessageService,
	) { }
	public profileDetails: Customer = {} as Customer
	public hideNameChangepop = false;
	public hidePassChangePop = false;
	public accInfo: any;
	public id: string = '';

	public changeName = this._fb.group({

		firstName: ['', Validators.required],
		lastName: ['', Validators.required],

	});

	public passwordChange = this._fb.group({

		password: ['', Validators.required],
		confirmPassword: ['', Validators.required],

	});

	public close_pop(str: string) {
		if (str === "name") {
			this.hideNameChangepop = false;
		}
		else {
			this.hidePassChangePop = false;
		}
	}


	public open_pop(str: string) {
		let nameArray: string[] = this.profileDetails.tenant.name.split(' ');
		let lName: string = nameArray.splice(1).join(' ')
		if (str === "name") {
			this.hideNameChangepop = true;
		}
		else {
			this.hidePassChangePop = true;
		}

		this.changeName.patchValue({

			firstName: nameArray[0],
			lastName: lName
		})
	}

	public getAccountInfo() {

		this._globalService.customerProfile.subscribe((customer: Customer) => {
			this.profileDetails = customer;
			// console.log(this.profileDetails)
		})
		if (this._globalService.customerProfileData) this.profileDetails = this._globalService.customerProfileData;

	}

	public nameChangeSubmit(): void {

		if (!this.changeName.valid) {
			this._toast.error('Fields are/is empty', 'Some of fields are/is empty. Please Fill up the and proceed.');
			return
		}
		let fname: string = this.changeName.value.firstName!;
		let lname: string = this.changeName.value.lastName!;
		this.profileDetails.tenant.name = fname.trim() + ' ' + lname.trim();
		// console.log(this.profileDetails);
		this.updateProfileApi();

	}

	public updatePasswordSubmit(): void {

		if (!this.passwordChange.valid) {
			this._toast.error('Fields are/is empty', 'Some of fields are/is empty. Please Fill up the and proceed.');
			return
		}
		this.profileDetails.tenant.password = this.passwordChange.value.password!;
		this.updateProfileApi();

	}

	public ngOnInit(): void {
		this.getAccountInfo()
	}

	private updateProfileApi() {
		this._customerProfile.updtateCustomerInfo(
			RequestMapperService.UPDATE_CUSTOMER_PROFILE,
			this.profileDetails,
			() => {
			},
			() => {
			},
			(response: RaintreeResponse) => {
				this._toast.success('Username updated successfully','Username updated successfully.');
				// console.log(response['customer']);
				this._globalService.sendCustomerInfo(this.profileDetails);
				this.hideNameChangepop = false;
				this.hidePassChangePop = false;


			},
			() => {

			},
			() => {

			}
		)
	}
}
